import Box from '@mui/material/Box';
import { ReviewFooter } from './ReviewFooter';
import { ReviewHeader } from './ReviewHeader';
import { Review } from 'functions/src/types/firestore/Game/Review';
import { TypographyParagraphed } from '../TypographyParagraphed';

export type ReviewBodyProps = Pick<
  Review<Date>,
  | 'description'
  | 'dislikesCount'
  | 'likesCount'
  | 'author'
  | 'recommended'
  | 'gameVersion'
  | 'date'
>;

export function ReviewBody({
  description,
  dislikesCount,
  likesCount,
  author,
  date,
  gameVersion,
  recommended,
}: ReviewBodyProps) {
  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Box
        sx={{
          marginBottom: '16px',
        }}
      >
        <ReviewHeader recommended={recommended} author={author} />
      </Box>

      <Box
        sx={{
          marginBottom: '16px',
        }}
      >
        <TypographyParagraphed text={description} />
      </Box>

      <Box>
        <ReviewFooter
          dislikesCount={dislikesCount}
          likesCount={likesCount}
          date={date}
          gameVersion={gameVersion}
        />
      </Box>
    </Box>
  );
}
